<template>
  <div class="box">
    <div class="carousel-box">
      <div class="carousel">
        <el-carousel height="150px" autoplay class="text-box-parent" :append-to-body="true"
          :style="{ 'z-index': $store.state.index }">
          <el-carousel-item v-for="item in carouselImgList" :key="item.id">
            <div class="text-box" v-if="item.id === 1">
              <div class="one">掌动游戏</div>
              <div class="two">打造基于游戏的全产业链生态</div>
              <!-- <div class="three">业务模式</div> -->
            </div>
            <img @click="clickBanner(item)"
              :style="[{ width: '100%' }, { height: '100%' }, { cursor: item.id === 4 && 'pointer' }]"
              :src="windowWidth > 992 ? item.imgSrc : item.mobileImg" alt="" />
          </el-carousel-item>
        </el-carousel>
      </div>

    </div>
    <!-- 关于傲天 -->
    <div class="about">
      <div class="box">
        <div class="one">
          <!-- <div class="icon-title">
            <img src="../assets/titleIcon.png" alt="" />
          </div> -->
          <div class="title">关于傲天</div>
          <!-- <div class="icon-title">
            <img src="../assets/titleIcon.png" alt="" />
          </div> -->
        </div>
        <!-- <div class="two">ABOUT&nbsp;&nbsp;PALM</div> -->
        <!-- <div class="three">傲天致力于创造开放卓越的游戏生态</div> -->
        <div class="four">
          <div class="four-item">傲天科技有限公司是一家专业的游戏自主研发和运营、广告流量代理、发行代理公司，旗下拥有一家游戏出版公司，是微信广点通、字节巨量广二级代理商。</div>
          <div class="four-item">致力于技术创新与人才培养的年轻新生力公司。自2006年9月成立以来，傲天科技就怀抱着研发和推广出一流的游戏作品的梦想，</div>
          <div class="four-item">以责任、精益求精的态度和不断创新的技术实力开发精品游戏。</div>
        </div>
        <div class="mobile-four">
          <div class="four-item">
            傲天科技有限公司是一家专业的游戏自主研发和运营、广告流量代理、发行代理公司，旗下拥有一家游戏出版公司，
            以责任、精益求精的态度和不断创新的技术实力开发精品游戏。
            <!-- 公司秉承着“掌动科技，快乐生活”的理念，致力于游戏生态全产业链打造，为中国游戏创造开放卓越的游戏生态。 -->
          </div>
        </div>
        <!-- <div class="five">
          <div class="five-item">
            <div class="five-item-title">1200万</div>
            <div>傲天注册用户</div>
          </div>
          <div class="five-item">
            <div class="five-item-title">100+</div>
            <div>傲天开发游戏IP数</div>
          </div>
          <div class="five-item">
            <div class="five-item-title">top10</div>
            <div>杭州重点文化企业</div>
          </div>
        </div> -->
        <!-- <div class="six"> </div> -->
        <div class="seven">
          <div class="left">
            <div class="left-top"></div>
            <div class="left-text">
              我们充分利用微信平台的海量用户资源和强大的社交属性，结合我们专业的广告优化技术和策略，帮助客户实现广告效果的最大化。通过对用户数据的深入分析和挖掘，制定个性化的广告投放方案，确保每一分广告预算都能得到最佳的回报。
            </div>
          </div>
          <div class="right">
            <div class="right-top"></div>
            <div class="right-text">
              作为字节巨量广告的合作伙伴，我们深入理解和把握字节跳动旗下产品（如抖音、今日头条等）的用户特点和广告投放机制。我们拥有一支专业的广告优化团队，通过精准的用户定位和数据分析，制定个性化的广告策略，确保广告投放的精准性和有效性。
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 产品介绍 -->
    <!-- <div class="product">
      <div class="box">
        <div class="one">

          <div class="title">产品介绍</div>

        </div>
        <div class="two">
        </div>
        <div class="content">

          <div :class="{
            'content-top': true,
            active: BottomCurrentIndex === index,
          }" v-for="(item, index) in lunbo" :key="index">
            <div class="left">
              <img :src="item.imgSrc" alt="" style="border-radius: 10px;"/>
            </div>
            <div class="right">
              <div class="right-text-box">
                <div class="right-title">{{ item.title }}</div>
                <div class="line-box">
                  <div class="line1"></div>
                  <div class="line2"></div>
                </div>
                <div class="right-content">{{ item.content }}</div>

              </div>
            </div>
          </div>

          <div class="content-bottom">
            <div class="content-bottom-left" @click="leftBtn"></div>
            <div @click="bottomBtn(index)" v-for="(item, index) in lunbo" :key="index"
              :class="{ 'content-bottom-item': true, active: BottomCurrentIndex === index }">
              <img :src="item.iconImg" alt="" />
            </div>
            <div class="content-bottom-right" @click="rightBtn"></div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- 新产品介绍 -->
    <div class="newProduct">
      <div class="box">
        <div class="one">
          <div class="title">合作产品</div>
        </div>
        <div class="two">
        </div>
        <div class="content">
          <div class="content-item" v-for="(item, index) in lunbo" :key="index" @click="gotoGame(item)">
            <div class="top">
              <img :src="item.imgSrc" alt="">
            </div>
            <div class="bottom">
              <div class="title">{{ item.title }}</div>
              <div class="text">{{ item.content }}</div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <!-- 游戏视频 -->
    <!-- <div class="video">
      <div class="box">
        <div class="one">
          <div class="icon-title">
            <img src="../assets/titleIcon.png" alt="" />
          </div>
          <div class="title">旗下产品</div>
          <div class="icon-title">
            <img src="../assets/titleIcon.png" alt="" />
          </div>
        </div>
        <div class="two">GAME&nbsp;&nbsp;VIDEO</div>
        <div class="content">
          <div class="left">

            <video style="width: 100%; height: 100%; object-fit: fill" class="videoOne" :muted="mutedOneShow" :src="windowWidth>992?pcvideo.url1:mobilevideo.url1" :controls="mutedOneShow" :loop="false" :autoplay="mutedOneShow" ref="videoOne" :poster="windowWidth>992?videoImg[0].pcImg:videoImg[0].mobileImg"></video>
            <div class="left-bottom-shadow">
              <div class="title">《别吃鸡》第五季冬季乐园预告片</div>
            </div>
            <div class="left-playIcon" @click="leftPlayIconBtn">
              <img v-if="!mutedOneShow" src="../assets/playIcon.png" alt="" />
            </div>
          </div>
          <div class="right">
            <div class="right-top">
              <video style="height: 100%; width: 100%; object-fit: fill" class="videoTwo" :muted="mutedTwoShow" :src="windowWidth>992?pcvideo.url2:mobilevideo.url2" :controls="mutedTwoShow" :loop="false" :autoplay="mutedTwoShow" ref="videoTwo" :poster="windowWidth>992?videoImg[1].pcImg:videoImg[1].mobileImg"></video>
              <div class="left-bottom-shadow">
                <div class="title">《开心点点消》第五季冬季乐园预告片</div>
              </div>
              <div class="left-playIcon" @click="topPlayIconBtn">
                <img v-if="!mutedTwoShow" src="../assets/playIcon.png" alt="" />
              </div>
            </div>
            <div class="right-bottom">
              <video style="height: 100%; width: 100%; object-fit: fill" class="videoThree" :muted="mutedThreeShow" :src="windowWidth>992?pcvideo.url3:mobilevideo.url3" :controls="mutedThreeShow" :loop="false" :autoplay="mutedThreeShow" ref="videoThree" :poster="windowWidth>992?videoImg[2].pcImg:videoImg[2].mobileImg"></video>
              <div class="left-bottom-shadow">
                <div class="title">《奔跑吧原始人》第五季冬季乐园预告片</div>
              </div>
              <div class="left-playIcon" @click="bottomPlayIconBtn">
                <img v-if="!mutedThreeShow" src="../assets/playIcon.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- 商务合作 -->
    <!-- <div class="cooperation">
      <div class="box">
        <div class="textOne">CONTACT</div>
        <div class="textTwo">商务合作</div>
        <div class="btn">
          <div class="btn-box" @click="contactBtn">
            <div>联系我们</div>
            <div class="phone-icon">
              <img src="../assets/phone.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div> -->

  </div>
</template>

<script>
export default {
  data () {
    return {
      videoImg: [
        {
          pcImg: require('@/assets/newImg/别吃鸡/960x500.png'),
          mobileImg: require('@/assets/mobile/mobileVideo1.png')
        },
        {
          pcImg: require('@/assets/newImg/开心点点消.png'),
          mobileImg: require('@/assets/mobile/mobileVideo2.png')
        },
        {
          pcImg: require('@/assets/newImg/奔跑吧原始人.jpg'),
          mobileImg: require('@/assets/mobile/mobileVideo3.png')
        }
      ],

      pcvideo: {
        url1: require('@/assets/video/别吃鸡.mp4'),
        url2: require('@/assets/video/点点消.mp4'),
        url3: require('@/assets/video/奔跑吧原始人.mp4')
      },
      mobilevideo: {
        url1: require('@/assets/mobileVideo/别吃鸡.mp4'),
        url2: require('@/assets/mobileVideo/开心点点消.mp4'),
        url3: require('@/assets/mobileVideo/奔跑吧原始人.mp4')
      },
      mutedOneShow: false,
      mutedTwoShow: false,
      mutedThreeShow: false,
      carouselImgList: [
        // { id: 1, imgSrc: require('../assets/pc/pc_banner1.jpg'), mobileImg: require('../assets/pc/pc_banner1.jpg') },
        { id: 2, imgSrc: require('../assets/newImg/sdfc.png'), mobileImg: require('../assets/newImg/sdfc.png') },
        { id: 3, imgSrc: require('../assets/newImg/yyxfc.png'), mobileImg: require('../assets/newImg/yyxfc.png') },
        { id: 4, imgSrc: require('../assets/pc/pc_banner3.png'), mobileImg: require('../assets/pc/pc_banner3.png') }

        // { id: 4, imgSrc: require('../assets/pc_yexfc.png'), mobileImg: require('../assets/mb_yexfc.png') },
        // { id: 3, imgSrc: require('../assets/lunbo/banner2x2.png'), mobileImg: require('../assets/mobile/mobileBanner3.png') }

      ],
      lunbo: [
        {
          id: 1,
          iconImg: require('../assets/傲天/赛道飞车1.png'),
          imgSrc: require('../assets/傲天/赛道飞车.png'),
          title: '赛道飞车',
          content:
            '《赛道飞车》是一款刺激、惊险的赛车游戏，让玩家在虚拟的赛道上尽情驰骋。这款游戏不仅具备高度的真实感，还能带给你极致的快感和冒险体验。无论你是赛车迷还是喜欢挑战的玩家，《赛道飞车》都能满足你对速度和驾驶的热爱。 首先，《赛道飞车》拥有逼真的游戏画面和出色的音效，为玩家呈现出一个精彩绝伦的赛车世界。'
        },
        {
          id: 2,
          iconImg: require('../assets/傲天/水果特工队1.png'),
          imgSrc: require('../assets/傲天/水果特工队.png'),
          title: '水果特工队',
          content:
            '《水果特工队》简介：水果特工队是一款十分有趣的休闲益智类手游，游戏采用了非常好玩有趣的消除类游戏玩法，玩家在游戏中需要连接相同的三国水果，将它们消除，来获得更高的分数！并且游戏中有超多的关卡等你来挑战哦！'
        },
        // {
        //   id: 3,
        //   iconImg: require('../assets/傲天/武林秘籍1.png'),
        //   imgSrc: require('../assets/傲天/武林秘籍.png'),
        //   title: '武林秘籍',
        //   content:
        //     '《武林秘籍》简介：《武林秘籍》故事背景架空于历史，讲述上古时代猛士之国之称的猛将国---虎贲，修炼意念和心智的圣城---青龙与以经济和技术为主的匠城---武玄三个强势大国之间的恩怨情仇，玩家自由选择国家之后即可开始亲自建筑心中久违的武侠世界，黄沙滚滚之漠北，竹海摇曳之南蜀，海川纵横之沧澜，造就了风格迥异的江湖世界。勾心斗角争权夺利的皇城，战火纷飞血染江山的边疆战地还有青竹林立与世无争的世外桃源，将会让《武林秘籍》的玩家流连忘返。'
        // },
        // {
        //   id: 4,
        //   iconImg: require('../assets/傲天/英雄美人1.png'),
        //   imgSrc: require('../assets/傲天/英雄美人.png'),
        //   title: '英雄美人',
        //   content:
        //     '《英雄美人》是一款大型2D精品武侠网游,秉承着全新的设计理念,开创国内网游之先河,采用英雄、美人两个不同视角来诠释游戏,将以鲜明的风格带给玩家全新的感受。'
        // },
        {
          id: 5,
          iconImg: require('../assets/傲天/越野小飞车1.png'),
          imgSrc: require('../assets/傲天/越野小飞车.png'),
          title: '越野小飞车',
          content:
            '《越野小飞车》是类似登山赛车的全新驾驶突破游戏。驾驶自己喜欢的车辆完成各种挑战,在挑战中掌握更多的驾驶技巧,会帮助你更好地完成突破,克服关卡中的困难和障碍,完成突破获得奖励!可以改装你的越野车,提高车辆各方面的性能,让你以后更容易突破关卡。'
        },
        {
          id: 6,
          iconImg: require('../assets/傲天/最牛弓射手.png'),
          imgSrc: require('../assets/傲天/最牛弓射手.png'),
          title: '最牛弓射手',
          content:
            '《最牛弓箭手》是一款休闲益智游戏，游戏采用清新简约的画面，以弓箭射击为主要玩法，在这款游戏中，你并不需要让你的箭矢射中靶心，而是让它从靶沿的各个方向贯穿靶身。还要小心不要让射出的箭矢不要撞到已经射中的箭矢，是时候表演真正的技术了。'
        },
        {
          id: 7,
          iconImg: require('../assets/傲天/赛道飞车1.png'),
          imgSrc: require('../assets/傲天/侠隐风云.png'),
          title: '侠隐风云',
          content:
            '侠隐风云起，江湖浪潮生。《侠隐风云》是一款大型的3D动作MMORPG游戏。视角自由切换，连贯的武侠招式，炫酷的技能特效，致力为玩家打造畅快的战斗体验。'
        },
        {
          id: 8,
          iconImg: require('../assets/傲天/水果特工队1.png'),
          imgSrc: require('../assets/傲天/三足鼎立.jpg'),
          title: '三足鼎立',
          content:
            '《三足鼎立》是一款以三国作为题材的策略塔防类游戏，游戏中采用了黑灰色的画风设计，以便于给玩家还原出更具真实性的三国史诗战役'
        },
        {
          id: 9,
          iconImg: require('../assets/傲天/坦克神兵.png'),
          imgSrc: require('../assets/傲天/坦克神兵.png'),
          title: '坦克神兵',
          content:
            '《坦克神兵》是一款以Roguelike类游戏玩法为核心，通过翻开地砖遭遇各种随机事件及怪物的形式来探索战场。每辆坦克都拥有专属技能与特殊效果，通过加装不同类型的配件强化自身能力。在游戏中，玩家可以自定义坦克，通过组合搭配出多样不同的技能释放杀伤力，挑战并击败强大的BOSS。'
        }
      ],
      index: 1,
      BottomCurrentIndex: 0,
      windowWidth: document.documentElement.clientWidth
    }
  },
  methods: {
    leftBtn () {
      if (this.BottomCurrentIndex !== 0) {
        this.BottomCurrentIndex--
      } else {
        this.BottomCurrentIndex = 2
      }
    },
    rightBtn () {
      if (this.BottomCurrentIndex !== 2) {
        this.BottomCurrentIndex++
      } else {
        this.BottomCurrentIndex = 0
      }
    },
    clickBanner (item) {
      if (item.id === 4) {
        window.open('https://u.zhongan.com/?business_id=63100187026010&utm_source=zyyl', '_blank')
      }
    },
    bottomBtn (index) {
      this.BottomCurrentIndex = index
    },
    leftPlayIconBtn () {
      console.log(11)
      this.mutedOneShow = true
      this.$refs.videoOne.play()
    },
    topPlayIconBtn () {
      this.mutedTwoShow = true
      this.$refs.videoTwo.play()
    },
    bottomPlayIconBtn () {
      this.mutedThreeShow = true
      this.$refs.videoThree.play()
    },
    moreBtn () {
      this.$router.push('/game')
    },
    contactBtn () {
      this.$router.push('/contact')
    },
    gotoGame (item) {
      if (item.id === 9) {
        window.open('https://www.taptap.cn/app/714103 ', '_blank')
      }
    }
  },
  watch: {
    // windowWidth: {
    //   handler (newVal, oldVal) {
    //     console.log(newVal, oldVal)
    //   }
    // }
  },
  created () {
    window.scrollTo(0, 0)
    // console.log('window.innerWidth', windowWidth)
  }
}
</script>

<style lang="scss" scoped>
.box {
  padding: 50px 0 0 0;
}

// pc端
@media (min-width: 992px) {
  img {
    width: 100%;
    height: 100%;
  }

  // 轮播图

  .carousel-box {
    width: 100%;

    // display: flex;
    // justify-content: center;
    .carousel {
      // width: 1500px;
      width: 1400px;
      height: 500px;
      margin: 0 auto;

      ::v-deep .el-carousel__arrow {
        background-color: rgba(31, 45, 61, 0.5);
        font-weight: 700;
      }

      ::v-deep .el-carousel__container {
        height: 500px !important;
      }

      ::v-deep .el-carousel__button {
        background-color: #01bdb0;
      }

      ::v-deep .el-carousel__indicators.el-carousel__indicators--horizontal {
        bottom: 40px;

        .el-carousel__button {
          width: 59px;
          height: 4px;
        }
      }

      .text-box-parent {
        position: relative;

        .text-box {
          position: absolute;
          // background-color: red;

          z-index: 99;
          top: 50%;
          left: 150px;
          transform: translateY(-50%);

          .one {
            font-size: 30px;
            color: #29262d;
            margin-bottom: 15px;
            letter-spacing: 1px;
          }

          .two {
            font-size: 36px;
            color: #29262d;
            margin-bottom: 15px;
            letter-spacing: 2px;
          }

          .three {
            text-align: center;
            line-height: 30px;
            width: 100px;
            height: 30px;
            background-color: #01bdb0;
            font-size: 14px;
            color: #fff;
            border-radius: 5px;
            cursor: pointer;
          }
        }
      }
    }
  }

  // 关于掌动
  .about {
    @media (min-width: 992px) {
      height: 650px;
      margin-top: 20px;
    }

    // background-color: #ffffff;
    // background-color:aqua;

    display: flex;
    justify-content: center;

    //pc端关于内容样式
    @media (min-width: 992px) {
      .box {
        text-align: center;
        width: 1400px;
        // background-image: linear-gradient(to bottom, #01bdb0, #abf8fe, #4eefff);
        // background-color: #9ff4f9;

        .one {
          // background-color: antiquewhite;
          // text-align: center;
          // background-color: aliceblue;
          // line-height: 100px;
          // width: 200px;
          // height: 100px;
          display: flex;
          justify-content: center;
          align-items: center;

          .icon-title {
            width: 20px;
            height: 33px;

            // background-color:#01bdb0 ;
            img {
              width: 100%;
              height: 100%;
            }
          }

          .title {
            text-align: center;
            line-height: 25px;
            font-size: 25px;
            color: #000000;
            margin: 0 8px;
            // position: relative;

            // &::before {
            //   content: ' ';
            //   position: absolute;
            //   display: block;
            //   width: 5px;
            //   height: 5px;
            //   border-radius: 50%;
            //   background-color: #01bdb0;
            //   top: 50%;
            //   transform: translateY(-50%);
            //   left: 595px;
            // }

            // &::after {
            //   content: ' ';
            //   position: absolute;
            //   display: block;
            //   width: 5px;
            //   height: 5px;
            //   border-radius: 50%;
            //   background-color: #01bdb0;
            //   top: 50%;
            //   transform: translateY(-50%);
            //   right: 595px;
            // }
          }
        }

        .two {
          color: #a7a7a7;
          font-size: 25px;
          font-family: Fontsstyle1;
          font-weight: 300;
          letter-spacing: 2px;
        }

        .three {
          margin: 30px 0;
          font-size: 36px;
        }

        .four {
          font-size: 16px;
          margin-top: 40px;

          .four-item:nth-child(2) {
            margin: 10px 0;
          }
        }

        .mobile-four {
          display: none;
        }

        .five {
          display: flex;
          justify-content: center;
          margin-top: 40px;

          .five-item:nth-child(2) {
            margin: 0 100px;
          }

          .five-item-title {
            // font-weight: 700;
            color: #000000;
            font-size: 45px;
          }

          .five-item {
            font-size: 16px;
          }
        }

        // .six {
        //   margin-top: 40px;
        //   height: 600px;
        //   background: url("../assets/傲天/company.png") no-repeat;
        //   background-size: 100% 100%;
        // }
        .seven {
          // background-color: red;
          height: 500px;
          display: flex;
          margin-top: 50px;

          .left {
            width: 50%;
            // background-color: yellow;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 0 150px;

            .left-top {
              width: 300px;
              height: 200px;
              // background-color: red;
              background: url("../assets/傲天/about1.png") no-repeat;
              background-size: 100% 100%;
              margin-bottom: 40px;
            }

            .left-text {
              text-align: left;
              text-indent: 2em;
            }
          }

          .right {
            width: 50%;
            // background-color: blue;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 0 150px;

            .right-top {
              width: 300px;
              height: 200px;
              // background-color: red;
              background: url("../assets/傲天/about2.jpg") no-repeat;
              background-size: 100% 100%;
              margin-bottom: 40px;
            }

            .right-text {
              text-align: left;
              text-indent: 2em;
            }

          }
        }
      }
    }
  }

  //产品介绍
  .product {
    display: flex;
    justify-content: center;
    // background-color: aliceblue;
    height: 700px;
    // padding: 0 10% 0 10%;
    // background-color: brown;

    .box {
      text-align: center;
      width: 100%;
      width: 1400px;
      padding: 0;

      // background-image: linear-gradient(to bottom, #01bdb0, #abf8fe, #4eefff);

      .one {
        // background-color: antiquewhite;
        // text-align: center;
        // background-color: aliceblue;
        // line-height: 100px;
        // width: 200px;
        // height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;

        .icon-title {
          width: 20px;
          height: 33px;

          // background-color:#01bdb0 ;
          img {
            width: 100%;
            height: 100%;
          }
        }

        .title {
          text-align: center;
          line-height: 25px;
          font-size: 25px;
          color: #000000;
          margin: 0 8px;
          // position: relative;

          // &::before {
          //   content: ' ';
          //   position: absolute;
          //   display: block;
          //   width: 5px;
          //   height: 5px;
          //   border-radius: 50%;
          //   background-color: #01bdb0;
          //   top: 50%;
          //   transform: translateY(-50%);
          //   left: 595px;
          // }

          // &::after {
          //   content: ' ';
          //   position: absolute;
          //   display: block;
          //   width: 5px;
          //   height: 5px;
          //   border-radius: 50%;
          //   background-color: #01bdb0;
          //   top: 50%;
          //   transform: translateY(-50%);
          //   right: 595px;
          // }
        }
      }

      .two {
        color: #a7a7a7;
        font-size: 25px;
        font-family: Fontsstyle1;
        font-weight: 300;
        letter-spacing: 2px;
        margin-bottom: 40px;
      }

      .content {
        position: relative;

        .content-top {
          display: flex;
          // justify-content: space-between;
          height: 450px;
          // width: 100%;
          // opacity: 1;
          display: none;

          &.active {
            // opacity: 1;

            // height: 300px;
            // width: 100%;
            display: flex;
            // display: block;
          }

          .left {
            // flex: 1;
            width: 960px;
            height: 100%;

            // img {
            //   width: 100%;
            //   height: 100%;
            // }
            // background-color: aqua;
          }

          .right {
            width: 600px;
            height: 100%;
            // background-color: red;
            display: flex;
            flex-direction: column;
            justify-content: center;

            .right-text-box {
              margin-left: 200px;

              .right-title {
                margin-left: 135px;
                line-height: 80px;
                width: 215px;
                height: 80px;
                font-size: 43px;
                // font-weight: 700;
                // background-color: blue;
              }

              .line-box {
                display: flex;
                margin-left: 238px;

                .line1 {
                  width: 15px;
                  height: 3px;
                  margin-right: 10px;
                  background-color: #01bdb0;
                }

                .line2 {
                  width: 60px;
                  height: 3px;
                  background-color: #01bdb0;
                }
              }

              .right-content {
                text-align: left;
                margin-top: 10px;
                width: 434px;
                height: 200px;
                margin-left: -91px;
                text-indent: 2em !important;
                font-size: 15px;
                // background-color: aqua;
              }

              .more {
                width: 100px;
                height: 40px;
                background-color: #01bdb0;
                color: #fff;
                text-align: center;
                line-height: 40px;
                border-radius: 3px;
                font-size: 16px;
                cursor: pointer;

                &:hover {
                  background-color: rgba(255, 135, 20, 0.8);
                }

                span {
                  margin-left: 3px;
                }
              }
            }
          }
        }

        .content-bottom {
          display: flex;
          // justify-content: center;
          position: absolute;
          top: 491px;
          left: 50%;
          transform: translateX(-50%);

          .content-bottom-left {
            width: 40px;
            height: 55px;
            // background-color: red;
            background: url('../assets/home/role_left.png') no-repeat;
            background-size: 100% 100%;
            margin-right: 20px;
            cursor: pointer;
          }

          .content-bottom-right {
            width: 40px;
            height: 55px;
            // background-color: red;
            background: url('../assets/home/role_right.png') no-repeat;
            background-size: 100% 100%;
            cursor: pointer;
          }

          .content-bottom-item {
            cursor: pointer;
            border-radius: 5px;
            width: 60px;
            height: 60px;
            // background-color: green;
            margin-right: 20px;

            img {
              border-radius: 5px;
              object-fit: fill;
              width: 100%;
              height: 100%;
            }

            &.active {
              border: 2px solid #01bdb0;
            }
          }
        }
      }
    }
  }

  // 新产品介绍
  .newProduct {
    display: flex;
    justify-content: center;
    // background-color: aliceblue;
   // height: 1160px;
    // padding: 0 10% 0 10%;
    // background-color: brown;

    .box {
      width: 100%;
      width: 1400px;
      padding: 0;

      // background-image: linear-gradient(to bottom, #01bdb0, #abf8fe, #4eefff);

      .one {
        // background-color: antiquewhite;
        // text-align: center;
        // background-color: aliceblue;
        // line-height: 100px;
        // width: 200px;
        // height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;

        .icon-title {
          width: 20px;
          height: 33px;

          // background-color:#01bdb0 ;
          img {
            width: 100%;
            height: 100%;
          }
        }

        .title {
          text-align: center;
          line-height: 25px;
          font-size: 25px;
          color: #000000;
          margin: 0 8px;
          // position: relative;

          // &::before {
          //   content: ' ';
          //   position: absolute;
          //   display: block;
          //   width: 5px;
          //   height: 5px;
          //   border-radius: 50%;
          //   background-color: #01bdb0;
          //   top: 50%;
          //   transform: translateY(-50%);
          //   left: 595px;
          // }

          // &::after {
          //   content: ' ';
          //   position: absolute;
          //   display: block;
          //   width: 5px;
          //   height: 5px;
          //   border-radius: 50%;
          //   background-color: #01bdb0;
          //   top: 50%;
          //   transform: translateY(-50%);
          //   right: 595px;
          // }
        }
      }

      .two {
        color: #a7a7a7;
        font-size: 25px;
        font-family: Fontsstyle1;
        font-weight: 300;
        letter-spacing: 2px;
        margin-bottom: 40px;
      }

      .content {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: 50px;

        .content-item {
          height: 500px;
          width: 32.8%;
          // background-color: #a5bee0;
          margin-bottom: 40px;

          .top {
            width: 100%;
            height: 300px;
            /* 设置溢出隐藏 */
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              /* 设置放大比例 */
              transform: scale(1);
              /* 给图片添加过渡效果 */
              transition: all 1s;
            }

            img:hover {
              /* 设置放大比例 */
              transform: scale(1.2);
              cursor: pointer;
            }
          }

          .bottom {
            padding: 10px 20px;

            .title {
              font-weight: 700;
              font-size: 30px;
              margin-bottom: 10px;
            }

            .text {
              font-size: 14px;
              text-indent: 1em;
            }
          }
        }

        & .content-item:nth-child(3n) {
          margin-right: 0;
        }
      }
    }
  }

  //视频
  .video {
    display: flex;
    justify-content: center;
    // background-color: red;
    height: 630px;
    // padding: 0 100px 0 100px;
    // background-color: brown;

    .box {
      text-align: center;
      width: 100%;
      padding: 0;
      width: 1400px;
      // background-color: red;

      .one {
        // background-color: antiquewhite;
        // text-align: center;
        // background-color: aliceblue;
        // line-height: 100px;
        // width: 200px;
        // height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;

        .icon-title {
          width: 20px;
          height: 33px;

          // background-color:#01bdb0 ;
          img {
            width: 100%;
            height: 100%;
          }
        }

        .title {
          text-align: center;
          line-height: 25px;
          font-size: 25px;
          color: #000000;
          margin: 0 8px;
          // position: relative;

          // &::before {
          //   content: ' ';
          //   position: absolute;
          //   display: block;
          //   width: 5px;
          //   height: 5px;
          //   border-radius: 50%;
          //   background-color: #01bdb0;
          //   top: 50%;
          //   transform: translateY(-50%);
          //   left: 595px;
          // }

          // &::after {
          //   content: ' ';
          //   position: absolute;
          //   display: block;
          //   width: 5px;
          //   height: 5px;
          //   border-radius: 50%;
          //   background-color: #01bdb0;
          //   top: 50%;
          //   transform: translateY(-50%);
          //   right: 595px;
          // }
        }
      }

      .two {
        color: #a7a7a7;
        font-size: 25px;
        font-family: Fontsstyle1;
        font-weight: 300;
        letter-spacing: 2px;
        margin-bottom: 40px;
      }

      .content {
        display: flex;
        justify-content: space-between;

        .left {
          position: relative;
          width: 857px;
          height: 500px;
          // background-color: aqua;

          .left-bottom-shadow {
            position: absolute;
            bottom: 0;
            left: 0;
            // width: 789px;
            width: 100%;
            height: 50px;
            z-index: 99;
            background-color: rgba(20, 42, 61, 0.3);

            .title {
              color: #fff;
              font-size: 20px;
              text-align: left;
              line-height: 50px;
              font-weight: 300;
            }
          }

          .left-playIcon {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 100px;
            height: 100px;

            // background-color: red;
            img {
              width: 100%;
              height: 100%;
              cursor: pointer;
            }
          }
        }

        .right {
          // width: 400px;
          // // height: 150px;
          // height: 100%;
          // background-color: yellow;
          margin-left: 10px;

          .right-top {
            width: 529px;
            height: 242px;
            // background-color: burlywood;
            margin-bottom: 15px;
            position: relative;

            .left-bottom-shadow {
              position: absolute;
              bottom: 0;
              left: 0;
              // width: 789px;
              width: 100%;
              height: 50px;
              z-index: 99;
              background-color: rgba(20, 42, 61, 0.3);

              .title {
                color: #fff;
                font-size: 16px;
                text-align: left;
                line-height: 50px;
                font-weight: 300;
              }
            }

            .left-playIcon {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 70px;
              height: 70px;

              // background-color: red;
              img {
                width: 100%;
                height: 100%;
                cursor: pointer;
              }
            }
          }

          .right-bottom {
            width: 529px;
            height: 242px;
            // background-color: blue;
            position: relative;

            .left-bottom-shadow {
              position: absolute;
              bottom: 0;
              left: 0;
              // width: 789px;
              width: 100%;
              height: 50px;
              z-index: 99;
              background-color: rgba(20, 42, 61, 0.3);

              .title {
                color: #fff;
                font-size: 16px;
                text-align: left;
                line-height: 50px;
                font-weight: 300;
              }
            }

            .left-playIcon {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 70px;
              height: 70px;

              // background-color: red;
              img {
                width: 100%;
                height: 100%;
                cursor: pointer;
              }
            }
          }
        }
      }
    }
  }

  //商务合作
  .cooperation {
    display: flex;
    justify-content: center;
    align-items: center;
    // background-color: #036f9a;
    background-image: linear-gradient(to right top, #0d496c, #047895, #01bdb0);
    height: 300px;
    margin: 30px 0 50px 0;
    letter-spacing: 8px;

    // padding: 0 100px 0 100px;
    // background-color: brown;
    .box {
      text-align: center;
      padding: 0;

      .textOne {
        font-size: 40px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.5);
      }

      .textTwo {
        margin-top: -32px;
        font-size: 40px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
      }

      .btn {
        padding: 0;

        .btn-box {
          width: 127px;

          height: 30px;
          margin: 20px 0;
          display: flex;
          align-items: center;
          justify-content: center;
          // justify-content: center;
          background-color: #01bdb0;
          color: #ffebd8;
          letter-spacing: 1px;
          font-size: 14px;
          border-radius: 3px;

          .phone-icon {
            width: 15px;
            height: 15px;
            margin: -8px 0 0 3px;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }

  // 通栏底部

  .common-bottom {
    height: 250px;
    background-color: #01bdb0;

    .mobile-box {
      display: none;
    }

    .box {
      text-align: center;
      padding-top: 60px;

      .line {
        // width: 1920px;
        width: 100%;
        height: 1px;
        background: linear-gradient(225deg, rgba(255, 255, 255, 0) 0%, #ffffff 51%, rgba(255, 255, 255, 0) 100%);
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
      }

      .title {
        color: #ffebd8;
        font-size: 25px;
        margin: 20px 0;
      }

      .textOne {
        color: #ffebd8;
        font-size: 14px;
        margin-bottom: 15px;
      }

      .textTwo {
        color: #ffebd8;
        font-size: 14px;
      }
    }
  }
}

// 移动端
@media (max-width: 992px) {
  img {
    width: 100%;
    height: 100%;
  }

  ::v-deep .el-carousel__button {
    background-color: #01bdb0;
  }

  .icon-title {
    display: none;
  }

  //轮播图
  .carousel-box {
    .text-box-parent {
      // z-index: -1;
    }

    ::v-deep .el-carousel__container {
      // height: 250px !important;
    }
  }

  .text-box-parent {
    position: relative;

    .text-box {
      position: absolute;
      // background-color: red;
      z-index: 999;
      top: 50%;
      left: 69px;
      transform: translateY(-50%);

      .one {
        font-size: 12px;
        color: #191919;
        margin-bottom: 5px;
        font-weight: 500;
      }

      .two {
        font-size: 14px;
        color: #191919;
        margin-bottom: 5px;
        letter-spacing: 2px;
        font-weight: 500;
      }

      .three {
        text-align: center;
        line-height: 30px;
        width: 70px;
        height: 30px;
        background-color: #01bdb0;
        font-size: 12px;
        color: #fff;
        border-radius: 5px;
        cursor: pointer;
      }
    }
  }

  .about {
    @media (max-width: 992px) {
      height: 570px;
      margin-bottom: 20px;
    }

    display: flex;
    justify-content: center;
    // background-color: aqua;

    .box {
      padding: 20px 0 0 0;
      text-align: center;
      // width: 1200px;

      .one {
        // background-color: antiquewhite;
        // text-align: center;
        // background-color: aliceblue;
        // line-height: 100px;
        // width: 200px;
        // height: 100px;

        .title {
          font-size: 20px;
          color: #01bdb0;
          position: relative;

          &::before {
            content: ' ';
            position: absolute;
            display: block;
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background-color: #01bdb0;
            top: 50%;
            transform: translateY(-50%);
            left: 36%;
            // transform: translatex(-50%);

          }

          &::after {
            content: ' ';
            position: absolute;
            display: block;
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background-color: #01bdb0;
            top: 50%;
            transform: translateY(-50%);
            right: 36%;
          }
        }
      }

      .two {
        color: #a7a7a7;
        font-size: 20px;
        font-family: Fontsstyle1;
        font-weight: 300;
        // letter-spacing: 2px;
      }

      .three {
        margin: 5px 0;
        font-size: 18px;
        color: #000000;
        // font-size: 32px;
      }

      .four {
        display: none;
      }

      .mobile-four {
        font-size: 12px;
        margin: 20px 0;

        .four-item {
          text-align: center;
          padding: 0 10px;
          text-indent: 2em;
          font-size: 12px;
        }

        .four-item:nth-child(2) {
          margin: 10px 0;
        }
      }

      .five {
        display: flex;
        justify-content: center;
        margin-top: 10px;
        font-size: 12px;

        .five-item:nth-child(2) {
          margin: 0 25px;
        }

        .five-item-title {
          // font-weight: 700;
          color: #000000;
          font-size: 20px;
        }
      }

      .six {
        margin-top: 10px;
        height: 200px;
        background: url("../assets/傲天/company.png") no-repeat;
        background-size: 100% 100%;
      }

      .seven {
        // background-color: red;
        // display: flex;
        margin-top: 30px;

        .left {
          width: 375px;
          // background-color: yellow;
          display: flex;
          flex-direction: column;
          align-items: center;
          // padding: 0 150px;

          .left-top {
            width: 150px;
            height: 75px;
            // background-color: red;
            background: url("../assets/傲天/about1.png") no-repeat;
            background-size: 100% 100%;
            margin-bottom: 40px;
          }

          .left-text {
            text-align: left;
            text-indent: 2em;
            font-size: 12px;
            padding: 0 10px;
          }
        }

        .right {
          width: 375px;
          // background-color: blue;
          margin-top: 40px;
          display: flex;
          flex-direction: column;
          align-items: center;

          .right-top {
            width: 150px;
              height: 75px;
            // background-color: red;
            background: url("../assets/傲天/about2.jpg") no-repeat;
            background-size: 100% 100%;
            margin-bottom: 40px;
          }

          .right-text {
            text-align: left;
            text-indent: 2em;
            font-size: 12px;
            padding: 0 10px;
          }

        }
      }
    }
  }

  //产品介绍
  .product {
    img {
      width: 100%;
      height: 100%;
    }

    display: flex;
    justify-content: center;
    // background-color: aliceblue;
    height: 280px;
    padding: 0 20px;
    // background-color: brown;

    .box {
      text-align: center;
      width: 100%;
      padding: 0;
      // background-color: red;

      .one {
        // background-color: antiquewhite;
        // text-align: center;
        // background-color: aliceblue;
        // line-height: 100px;
        // width: 200px;
        // height: 100px;

        .title {
          font-size: 20px;
          color: #01bdb0;
          position: relative;

          &::before {
            content: ' ';
            position: absolute;
            display: block;
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background-color: #01bdb0;
            top: 50%;
            transform: translateY(-50%);
            left: 34.2%;
          }

          &::after {
            content: ' ';
            position: absolute;
            display: block;
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background-color: #01bdb0;
            top: 50%;
            transform: translateY(-50%);
            right: 34.2%;
          }
        }
      }

      .two {
        color: #a7a7a7;
        font-size: 20px;
        margin-bottom: 10px;
        font-family: Fontsstyle1;
        font-weight: 300;
        // letter-spacing: 2px;
      }

      .content {
        position: relative;

        .content-top {
          display: flex;
          // justify-content: space-between;
          height: 150px;
          // width: 100%;
          // opacity: 1;
          display: none;

          &.active {
            // opacity: 1;

            // height: 100px;
            // width: 100%;
            display: flex;
            // display: block;
          }

          .left {
            // flex: 1;
            width: 595px;
            height: 100%;

            // img {
            //   width: 100%;
            //   height: 100%;
            // }
            // background-color: aqua;
          }

          .right {
            width: 278px;
            height: 100%;
            // background-color: red;
            display: flex;
            flex-direction: column;
            justify-content: center;

            .right-text-box {
              .right-title {
                font-size: 20px;
                margin-bottom: 5px;
                // margin-left: 135px;
                // line-height: 80px;
                // width: 100px;
                // height: 20px;
                // font-size: 16px;
                // font-weight: 700;
                // background-color: blue;
              }

              .line-box {
                display: flex;
                margin-left: 47px;
                // margin-left: 238px;

                .line1 {
                  width: 9px;
                  height: 1px;
                  margin-right: 10px;
                  background-color: #01bdb0;
                }

                .line2 {
                  width: 30px;
                  height: 1px;
                  background-color: #01bdb0;
                }
              }

              .right-content {
                display: none;
              }

              .more {
                margin: 0 auto;
                margin-top: 20px;
                width: 50px;
                height: 25px;
                background-color: #01bdb0;
                color: #fff;
                text-align: center;
                line-height: 25px;
                border-radius: 2px;
                font-size: 12px;
                cursor: pointer;

                &:hover {
                  background-color: rgba(255, 135, 20, 0.8);
                }

                span {
                  margin-left: 1px;
                }
              }
            }
          }
        }

        .content-bottom {
          display: flex;
          // justify-content: center;
          position: absolute;
          align-items: center;
          // left: 64px;
          top: 170px;
          left: 50%;
          transform: translateX(-50%);
          // height: 60px;

          .content-bottom-left {
            width: 30px;
            height: 40px;
            // background-color: red;
            background: url('../assets/home/role_left.png') no-repeat;
            background-size: 100% 100%;
            margin-right: 10px;
            cursor: pointer;
          }

          .content-bottom-right {
            width: 30px;
            height: 40px;
            // background-color: red;
            background: url('../assets/home/role_right.png') no-repeat;
            background-size: 100% 100%;
            cursor: pointer;
          }

          .content-bottom-item {
            width: 40px;
            height: 40px;
            // background-color: green;
            margin-right: 10px;
            border-radius: 3px;
            // border: 1px solid red;
            display: flex;
            align-items: center;

            img {
              // width: 100%;
              // height: 100%;
              width: 38px;
              height: 38px;
              // border-radius: 3px;
              // object-fit: fill;
            }

            &.active {
              border: 1px solid #01bdb0;
            }
          }
        }
      }
    }
  }

  // 新产品介绍
  .newProduct {
    img {
      width: 100%;
      height: 100%;
    }

    display: flex;
    justify-content: center;
    // background-color: aliceblue;
    // height: 580px;
    padding: 0 10px;
    // background-color: brown;

    .box {
      text-align: center;
      width: 100%;
      padding: 0;
      // background-color: red;

      .one {
        // background-color: antiquewhite;
        // text-align: center;
        // background-color: aliceblue;
        // line-height: 100px;
        // width: 200px;
        // height: 100px;

        .title {
          font-size: 20px;
          color: #01bdb0;
          position: relative;

          &::before {
            content: ' ';
            position: absolute;
            display: block;
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background-color: #01bdb0;
            top: 50%;
            transform: translateY(-50%);
            left: 34.2%;
          }

          &::after {
            content: ' ';
            position: absolute;
            display: block;
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background-color: #01bdb0;
            top: 50%;
            transform: translateY(-50%);
            right: 34.2%;
          }
        }
      }

      .two {
        color: #a7a7a7;
        font-size: 20px;
        margin-bottom: 10px;
        font-family: Fontsstyle1;
        font-weight: 300;
        // letter-spacing: 2px;
      }

      .content {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: 20px;
        .content-item {
          height: 175px;
          width: 49%;
          // background-color: #a5bee0;
          margin-bottom: 10px;

          .top {
            width: 100%;
            height: 130px;
            /* 设置溢出隐藏 */
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              /* 设置放大比例 */
              transform: scale(1);
              /* 给图片添加过渡效果 */
              transition: all 1s;
            }

            img:hover {
              /* 设置放大比例 */
              transform: scale(1.2);
              cursor: pointer;
            }
          }

          .bottom {
            padding: 10px 20px;

            .title {
              font-weight: 700;
              font-size: 15px;
              margin-bottom: 10px;
            }

            .text {
              display: none;
              font-size: 14px;
            }
          }
        }

        & .content-item:nth-child(3n) {
          margin-right: 0;
        }
      }
    }
  }

  //游戏视频
  .video {
    margin-top: 15px;
    display: flex;
    justify-content: center;
    // background-color: red;
    // height: 500px;
    padding: 0 20px 0 20px;
    // background-color: brown;

    .box {
      text-align: center;
      width: 100%;
      padding: 0;
      // background-color: red;

      .one {
        // background-color: antiquewhite;
        // text-align: center;
        // background-color: aliceblue;
        // line-height: 100px;
        // width: 200px;
        // height: 100px;

        .title {
          font-size: 20px;
          color: #01bdb0;
          position: relative;

          &::before {
            content: ' ';
            position: absolute;
            display: block;
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background-color: #01bdb0;
            top: 50%;
            transform: translateY(-50%);
            left: 34.2%;
          }

          &::after {
            content: ' ';
            position: absolute;
            display: block;
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background-color: #01bdb0;
            top: 50%;
            transform: translateY(-50%);
            right: 34.2%;
          }
        }
      }

      .two {
        color: #a7a7a7;
        font-size: 20px;
        margin-bottom: 10px;
        font-family: Fontsstyle1;
        font-weight: 300;
        // letter-spacing: 2px;
      }

      .content {
        // display: flex;

        .left {
          position: relative;
          width: 100%;
          height: 500px;
          // background-color: aqua;

          .left-bottom-shadow {
            position: absolute;
            bottom: 0;
            left: 0;
            // width: 789px;
            width: 100%;
            height: 30px;
            z-index: 999;
            background-color: rgba(20, 42, 61, 0.3);

            .title {
              color: #fff;

              font-size: 12px;
              text-align: left;
              line-height: 30px;
              font-weight: 300;
            }
          }

          .left-playIcon {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 50px;
            height: 50px;

            // background-color: red;
            img {
              width: 100%;
              height: 100%;
              cursor: pointer;
            }
          }
        }

        .right {
          // display: flex;
          width: 100%;
          justify-content: space-between;
          margin-top: 15px;
          // width: 400px;
          // // height: 150px;
          // height: 100%;
          // background-color: yellow;
          // margin-left: 5px;

          .right-top {
            width: 100%;
            height: 500px;
            // background-color: burlywood;
            margin-bottom: 15px;
            // margin-right: 10px;
            position: relative;

            .left-bottom-shadow {
              position: absolute;
              bottom: 0;
              left: 0;
              // width: 789px;
              width: 100%;
              height: 30px;
              z-index: 999;
              background-color: rgba(20, 42, 61, 0.3);

              .title {
                color: #fff;

                font-size: 12px;
                text-align: left;
                line-height: 30px;
                font-weight: 300;
              }
            }

            .left-playIcon {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 50px;
              height: 50px;

              // background-color: red;
              img {
                width: 100%;
                height: 100%;
                cursor: pointer;
              }
            }
          }

          .right-bottom {
            width: 100%;
            height: 500px;
            // background-color: blue;
            position: relative;

            .left-bottom-shadow {
              position: absolute;
              bottom: 0;
              left: 0;
              // width: 789px;
              width: 100%;
              height: 30px;
              z-index: 999;
              background-color: rgba(20, 42, 61, 0.3);

              .title {
                color: #fff;
                font-size: 12px;
                text-align: left;
                line-height: 30px;
                font-weight: 300;
              }
            }

            .left-playIcon {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 50px;
              height: 50px;

              // background-color: red;
              img {
                width: 100%;
                height: 100%;
                cursor: pointer;
              }
            }
          }
        }
      }
    }
  }

  //商务合作
  .cooperation {
    display: flex;
    justify-content: center;
    align-items: center;
    // background-color: #036f9a;
    background-image: linear-gradient(to right top, #0d496c, #047895, #01bdb0);
    height: 150px;
    margin: 15px 0;
    letter-spacing: 4px;

    // padding: 0 100px 0 100px;
    // background-color: brown;
    .box {
      text-align: center;
      padding: 0;

      .textOne {
        font-size: 20px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.5);
      }

      .textTwo {
        margin-top: -16px;
        font-size: 20px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
      }

      .btn {

        // padding: 0;
        .btn-box {
          width: 86px;
          height: 30px;
          // margin: 20px 0;
          display: flex;
          align-items: center;
          justify-content: center;
          // justify-content: center;
          background-color: #01bdb0;
          color: #ffebd8;
          letter-spacing: 1px;
          font-size: 12px;
          border-radius: 3px;

          .phone-icon {
            width: 12px;
            height: 12px;
            margin: -8px 0 0 3px;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }

  // 通栏底部

  .common-bottom {
    height: 150px;
    background-color: #01bdb0;

    .box {
      display: none;
    }

    .mobile-box {
      padding: 24px 0 0 0;
      text-align: center;

      .line {
        // width: 1920px;
        width: 100%;
        height: 1px;
        background: linear-gradient(225deg, rgba(255, 255, 255, 0) 0%, #ffffff 51%, rgba(255, 255, 255, 0) 100%);
        // border-radius: 0px 0px 0px 0px;
        opacity: 1;
      }

      .title {
        color: #ffebd8;
        font-size: 16px;
        margin: 5px 0;
      }

      .textOne {
        color: #ffebd8;
        font-size: 10px;
        transform: scale(0.83333);

        // margin-bottom: 15px;
      }

      .textTwo {
        color: #ffebd8;
        font-size: 10px;
        transform: scale(0.83333);
      }
    }
  }
}
</style>
